/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/signInUser.config.json';
import axios from 'axios';
import { VApplication } from '@/application';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_EMAIL_DETAILS } from '../graphql';
import { StorageModule } from '@vlinder-web/storage-module-react';

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface IGetEmailDetailsMethods extends IPluginMethodMap {
  getEmailDetails(args: { email: string }): Promise<any>;
}

export class GetEmailDetailsService implements IAgentPlugin {
  readonly methods: IGetEmailDetailsMethods;
  constructor() {
    this.methods = {
      getEmailDetails: this.getEmailDetails.bind(this),
    };
  }

  async getEmailDetails(args: { email: string; apiURL: string }) {
    console.log(`getEmailDetails in service`, args);
    const storageService = StorageModule.getInstance();
    const graphqlModule = getGraphQLModule();
    console.log(`graphqlModule`, graphqlModule);
    const client = graphqlModule.getClient('graphql-gateway');
    console.log(`client`, client);
    try {
      if (client) {
        const res = await client.query({
          query: GET_EMAIL_DETAILS,
          variables: {
            where: {
              email: args?.email,
            },
          },
        });
        console.log(`res`, res);
        if (res?.data) {
          console.log(`getEmailDetails`, res?.data);
          const profileData = res?.data?.users
            ? this.getProfileData(res?.data?.users[0])
            : {};
          console.log(`profileData`, profileData);
          //const organization = this._getOrganizationData(profileData);
          storageService.set('myProfile', profileData, 'local');
          // storageService.set('organization', organization, 'session');
          return {
            ...profileData,
          };
        }
      }
    } catch (err: any) {
      console.log(`getEmailDetails error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }

  private getProfileData(data) {
    let _orgData: any = {};
    console.log(`data`, data);
    if (data?.employeeOfOrg) {
      console.log(`data?.employeeOfOrg`, data?.employeeOfOrg);
      _orgData = { ...data?.employeeOfOrg };
    } else if (
      data?.employedInOrgs &&
      Array.isArray(data?.employedInOrgs) &&
      data?.employedInOrgs.length > 0
    ) {
      console.log(`data?.employedInOrgs`, data?.employedInOrgs);
      _orgData = data?.employedInOrgs[0];
    }
    console.log(`_orgData`, _orgData);
    return { ...data, orgData: _orgData };
  }
}
